// Steps
export const VALIDATE_HCAPTCHA_TOKEN = 'VALIDATE_HCAPTCHA_TOKEN';
export const VALIDATE_HCAPTCHA_TOKEN_SUCCESS = 'VALIDATE_HCAPTCHA_TOKEN_SUCCESS';
export const VALIDATE_HCAPTCHA_TOKEN_FAIL = 'VALIDATE_HCAPTCHA_TOKEN_FAIL';
